"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
var renderSelected = function (selectedStatus, reversed) {
    var _a;
    if (selectedStatus) {
        return (React.createElement("div", { className: (0, classnames_1["default"])(styles_scss_1["default"].icon, (_a = {},
                _a[styles_scss_1["default"].reversed] = reversed,
                _a)) }));
    }
    return;
};
var Radio = function (_a) {
    var _b, _c;
    var id = _a.id, automationId = _a.automationId, name = _a.name, value = _a.value, _d = _a.selectedStatus, selectedStatus = _d === void 0 ? false : _d, onChange = _a.onChange, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.reversed, reversed = _f === void 0 ? false : _f;
    return (React.createElement("span", null,
        React.createElement("input", { type: "radio", id: id, name: name, value: value, checked: selectedStatus, "data-automation-id": automationId, className: (0, classnames_1["default"])(styles_scss_1["default"].radioInput, (_b = {},
                _b[styles_scss_1["default"].reversed] = reversed,
                _b)), onChange: onChange, disabled: disabled }),
        React.createElement("span", { className: (0, classnames_1["default"])(styles_scss_1["default"].box, (_c = {},
                _c[styles_scss_1["default"].reversed] = reversed,
                _c)) }, renderSelected(selectedStatus, reversed))));
};
exports["default"] = Radio;
//# sourceMappingURL=Radio.js.map